import { render, staticRenderFns } from "./modalAcompanhar.vue?vue&type=template&id=bda8c73a&scoped=true&"
import script from "./modalAcompanhar.vue?vue&type=script&lang=js&"
export * from "./modalAcompanhar.vue?vue&type=script&lang=js&"
import style0 from "./modalAcompanhar.vue?vue&type=style&index=0&id=bda8c73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda8c73a",
  null
  
)

export default component.exports